export class TouchEventFunctionService {
  private bindTouchEvent: (url: string, ele: HTMLElement) => void;

  constructor() {
    this.bindTouchEvent = (url: string, ele: HTMLElement) => {};
  }

  setTouchEventFunction(func: (url: string, ele: HTMLElement) => void): void {
    this.bindTouchEvent = func;
  }

  get touchEventFunction(): Function {
    return this.bindTouchEvent;
  }
}

angular.module('ui-ng-university-text').service('ngTouchEventFunctionService', TouchEventFunctionService);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-text/src/services/touch_event_function_service.ts